import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "preview",
  "use": "preview-usage",
  "viewBox": "0 0 16.969 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16.969 10\" id=\"preview\">\n  <path fill-rule=\"evenodd\" d=\"M193.5,110a10.642,10.642,0,0,0-8.367,4.6,0.659,0.659,0,0,0,0,.793,9.905,9.905,0,0,0,16.734,0,0.659,0.659,0,0,0,0-.793A10.636,10.636,0,0,0,193.5,110h0Zm0.233,8.521a3.529,3.529,0,1,1,3.335-3.291,3.555,3.555,0,0,1-3.335,3.291h0Zm-0.107-1.627a1.9,1.9,0,1,1,1.8-1.774,1.909,1.909,0,0,1-1.8,1.774h0Zm0,0\" transform=\"translate(-185.031 -110)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/preview.svg
// module id = null
// module chunks = 